import type { CustomerTimelineTextConversationEntry } from "@repo/app-types/entities/performanceCustomer";
import type { CustomerTimelineRow } from "@repo/ui/customerTimeline/customerTimeline";
import { CustomerTimelineRowDetails } from "@repo/ui/customerTimeline/customerTimelineRowDetails";
import { IconMessage } from "@tabler/icons-react";
import {
  buildCustomerTimelineParticipant,
  renderTrailingText,
  type CustomerTimelineRowOptions,
} from "./timelineRowHelpers.js";

/** A voice agent's texts with the customer between two calls. */
export function renderTextConversationRow(
  entry: CustomerTimelineTextConversationEntry,
  options: CustomerTimelineRowOptions,
): Pick<CustomerTimelineRow, "icon" | "content"> {
  return {
    icon: <IconMessage className="size-4" />,
    content: (
      <CustomerTimelineRowDetails
        title="Text conversation"
        trailingAccessory={renderTrailingText(
          entry.message_count === 1
            ? "1 message"
            : `${entry.message_count} messages`,
        )}
        onOpen={() =>
          options.openInteraction(entry.grading_id, {
            textConversationId: entry.id,
          })
        }
        participants={[buildCustomerTimelineParticipant(entry.teammate)]}
      />
    ),
  };
}
